import { Injectable } from '@angular/core'
import { LocalStorageOptions } from './local-storage.type'

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public set(key: string, value: any, options?: LocalStorageOptions): void {
    const valueToSave = this.parsePreference('set', value, options)

    localStorage.setItem(key, valueToSave)
  }

  public get<T>(key: string, options?: LocalStorageOptions): T {
    let value = localStorage.getItem(key)

    value = this.parsePreference('get', value, options)

    return value as T
  }

  public remove(key: string): void {
    localStorage.removeItem(key)
  }

  private parsePreference(type: 'get' | 'set', value: any, options?: LocalStorageOptions): any {
    if (options?.asString) {
      return value
    }

    if (options?.asBoolean) {
      return this.valueAsBoolean(type, value)
    }

    if (options?.asNumber) {
      return this.valueAsNumber(type, value)
    }

    return this.valueAsObject(type, value)
  }

  private valueAsObject(type: 'get' | 'set', value: any): any {
    if (type === 'get') {
      return JSON.parse(value)
    }

    if (type === 'set') {
      return JSON.stringify(value)
    }

    return value
  }

  private valueAsBoolean(type: 'get' | 'set', value: any): any {
    if (type === 'get') {
      return value === 'true'
    }

    if (type === 'set') {
      return String(value)
    }

    return value
  }

  private valueAsNumber(type: 'get' | 'set', value: any): any {
    if (type === 'get') {
      return Number(value)
    }

    if (type === 'set') {
      return String(value)
    }

    return Number(value)
  }
}
